
export const initialState =  {
     chapterData:{
        data:{},
        loading:false,
        success:false,
        error:false
     }
}